import { Card, CardContent } from '@/components/ui/card';
import { TrendingDown, Clock } from 'lucide-react';

export const EconomicsSection = () => {
  const benefits = [
    {
      icon: TrendingDown,
      title: 'Bis zu 30 % Stromkostenersparnis',
      description:
        'durch optimiertes Lastmanagement und intelligente Ladetaktiken.',
    },
    {
      icon: Clock,
      title: 'ROI in 3–5 Jahren',
      description:
        'Amortisationszeiten sinken durch sinkende Batteriekosten und steigende Energiepreise.',
    },
  ];

  const stats = [
    { value: '30%', label: 'Kostensenkung durch Peak Shaving' },
    { value: '99,9%', label: 'Verfügbarkeit mit BESS Backup' },
    { value: '5x', label: 'Lebensdauer vs klassische USV' },
  ];

  return (
    <section id="economics" className="py-12 sm:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
              Wirtschaftlichkeit:
            </p>
            <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
              Energieeffizienz und Kosteneinsparungen
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl">
              Durch den gezielten Einsatz von BESS lassen sich die
              Betriebskosten eines Rechenzentrums signifikant senken.
              Peak-Shaving reduziert Spitzenlastbezüge, während
              Arbitrage-Strategien günstige Tarife optimal ausnutzen.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 items-start">
            {/* Benefits Cards */}
            <div className="md:col-span-2 space-y-6">
              {benefits.map((benefit, index) => (
                <Card
                  key={index}
                  className="border-border hover:border-primary/30 transition-all duration-300 hover:shadow-md group"
                >
                  <CardContent className="p-6 flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                      <benefit.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-heading font-semibold text-xl text-foreground mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-muted-foreground">
                        {benefit.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              ))}

              {/* ROI-Bild */}
              <img
                src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/8aj67uih_ROI.png"
                alt="Wirtschaftlichkeitsdiagramm – ROI-Analyse"
                className="w-full rounded-lg shadow-lg object-cover aspect-video"
                loading="lazy"
                data-testid="economics-roi-image"
              />
            </div>

            {/* Stats Box */}
            <Card className="lg:sticky lg:top-24 border-2 border-primary/20 shadow-lg">
              <CardContent className="p-8">
                <h3 className="font-heading font-semibold text-xl text-foreground mb-6">
                  Statistiken
                </h3>
                <div className="space-y-6">
                  {stats.map((stat, index) => (
                    <div key={index} className="text-center py-4 border-b border-border last:border-0">
                      <div className="font-heading font-bold text-4xl text-primary mb-2">
                        {stat.value}
                      </div>
                      <div className="text-sm text-muted-foreground leading-snug">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};